import { render, staticRenderFns } from "./CardStats.vue?vue&type=template&id=7798cbd6&"
import script from "./CardStats.vue?vue&type=script&lang=js&"
export * from "./CardStats.vue?vue&type=script&lang=js&"
import style0 from "./CardStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
